import { request, API_V1_PREFIX } from "./client";
import type { AnalyticsReport } from "./types";

export async function getAnalytics(
  token: string,
  schoolProfileId?: string,
  classId?: string,
  timeRange: string = "month",
  filters?: {
    startDate?: string;
    endDate?: string;
    minScore?: number;
    status?: string;
  }
): Promise<AnalyticsReport> {
  const params = new URLSearchParams();
  if (schoolProfileId) params.append("school_profile_id", schoolProfileId);
  if (classId && classId !== "all") params.append("class_id", classId);
  params.append("time_range", timeRange);
  
  if (filters) {
    if (filters.startDate) params.append("start_date", filters.startDate);
    if (filters.endDate) params.append("end_date", filters.endDate);
    if (filters.minScore !== undefined) params.append("min_score", filters.minScore.toString());
    if (filters.status) params.append("status", filters.status);
  }

  return request<AnalyticsReport>(
    `${API_V1_PREFIX}/reports/analytics?${params.toString()}`,
    { method: "GET" },
    { token }
  );
}
